export default "__VITE_ASSET__DZHHieHk__"